import { createDirectoryItemResponse, createDirectoryResponse } from './response-parsers/directory-response';

export class DirectoryProvider {
  constructor (imageService) {
    this._imageService = imageService;
  }

  list (path = '/') {
    return this._imageService.request({
      path,
      command: 'DIR',
      parseResponseDelegate: createDirectoryResponse
      // TODO: Handle error responses
      // 404: Not found can be returned if the requested path does not exist AND if the requested path is empty.
      // If empty folder, the response starts with: "Image record not found in database"
      // If not found, the response starts with "Unknown file"
    });
  }

  info (path) {
    return this._imageService.request({
      path,
      command: 'INFO',
      parseResponseDelegate: createDirectoryItemResponse
    });
  }
}
